module.exports = __webpack_public_path__ + "static/img/banner3.ce85025c.png";